import React, { createContext, useContext, useState } from "react";
import axios from "axios";
import { backendURL } from "../url";
// import { getUTCTimeString } from "../hooks/Date";

interface UserDetails {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  address?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  specialRequests?: string;
}

interface BookingContextType {
  selectedListing: any;
  setSelectedListing: (listing: any) => void;
  selectedDate: string;
  setSelectedDate: (date: string) => void;
  startTime: string;
  setStartTime: (time: string) => void;
  endTime: string;
  userDetails: UserDetails;
  setUserDetails: (user: UserDetails) => void;
  setEndTime: (time: string) => void;
  checkAvailability: () => Promise<boolean>;
  bookingId: string | null;
  setBookingId: (id: string | null) => void;
  timeRemaining: number;
  setTimeRemaining: (time: number) => void;
  confirmBooking: () => Promise<any>;
  createTempBooking: () => Promise<any>;
}

// This will hold the data of selected booking details
const BookingContext = createContext<BookingContextType | undefined>(undefined);

export const BookingProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [selectedListing, setSelectedListing] = useState<any>(null);
  const [selectedDate, setSelectedDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [bookingId, setBookingId] = useState<string | null>(null);
  const [timeRemaining, setTimeRemaining] = useState(0);
  const [userDetails, setUserDetails] = useState<UserDetails>({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    zipCode: "",
    specialRequests: "",
  });
  const userId = localStorage.getItem("userId");

  const checkAvailability = async () => {
    try {
      const { data } = await axios.post(
        `${backendURL}/api/booking/check-availability`,
        // `${process.env.REACT_APP_BACKEND_URL}/api/booking/check-availability`,
        {
          laneOrCageId: selectedListing?.id,
          bookingForDate: selectedDate,
          startTime,
          endTime,
        }
      );
      return data.available;
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  const confirmBooking = async () => {
    try {
      const response = await axios.post(
        `${backendURL}/api/booking/create-booking`,
        // `${process.env.REACT_APP_BACKEND_URL}/api/booking/create-booking`,
        {
          bookingId: bookingId,
          // startTime: getUTCTimeString(startTime),
          // endTime: getUTCTimeString(endTime),
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      return false;
    }
  };


  const createTempBooking = async () => {
    try {
      console.log("selectedDate", selectedDate);
      const formattedDate = new Date(selectedDate)
      const year = formattedDate.getFullYear();
      const month = String(formattedDate.getMonth() + 1).padStart(2, '0');
      const day = String(formattedDate.getDate()).padStart(2, '0');
      const formattedDateString = `${year}-${month}-${day}`;
      console.log("formattedDateString", formattedDateString);
      const response = await axios.post(
        `${backendURL}/api/booking/create-temp-booking`,
        // `${process.env.REACT_APP_BACKEND_URL}/api/booking/create-booking`,
        {
          user: userId ? userId : userDetails.email,
          laneOrCageId: selectedListing?.id,
          bookingForDate: formattedDateString,
          startTime: startTime,
          endTime: endTime,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  return (
    <BookingContext.Provider
      value={{
        selectedListing,
        setSelectedListing,
        selectedDate,
        setSelectedDate,
        startTime,
        setStartTime,
        endTime,
        setEndTime,
        userDetails,
        setUserDetails,
        checkAvailability,
        bookingId,
        setBookingId,
        timeRemaining,
        setTimeRemaining,
        confirmBooking,
        createTempBooking
      }}
    >
      {children}
    </BookingContext.Provider>
  );
};

export const useBooking = () => {
  const context = useContext(BookingContext);
  if (!context)
    throw new Error("useBooking must be used within a BookingProvider");
  return context;
};
